module.exports = __webpack_public_path__ + "media/home/interview-banner-206b0e57.jpg";